import React from "react";
import "./ComingSoonOverlay.scss";

interface ComingSoonOverlayProps {
    message?: string;
    link?: string;
}

export const ComingSoonOverlay: React.FC<ComingSoonOverlayProps> = ({
    message = "Coming very soon. Got ideas?",
    link = "#",
}) => {
    return (
        <div className="coming-soon-overlay">
            <div className="overlay-content">
                <p>{message}</p>
                <a href={link} target="_blank" rel="noopener noreferrer">
                    Give Your Input Here
                </a>
            </div>
        </div>
    );
};
